import { HTTPClient, propsToDate, propsToDatePaged } from "@abaco/web-common/src/HTTP";
import { dbGIStoStandardPage, PagedResults, PagingParams } from "@abaco/web-common/src/Paging";

export default class R2UApi {

    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    // public async getTest(pkCuaa: number, filter: string, paging: PagingParams): Promise<PagedResults<any>> {
    //     const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/plots/subjects/${pkCuaa}/dictionary_workers`, {
    //         params: {
    //             filter: filter ? `^subject_full_name like ${filter.toUpperCase()}` : undefined,
    //             offset: paging.offset,
    //             count: paging.count,
    //         }
    //     });
    //     return res.data;
    // }

}
